import { Headline } from '@components/designSystem/Headline'

function ErrorHandler({ message }: { message: string }) {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-6">
      <Headline i18nKey='common.error.serverError.message' />
      <span className='text-red-500'>{message}</span>
    </div>
  )
}

export default ErrorHandler
